import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnInit,
  OnChanges,
  AfterContentInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export interface DateDropdown {
  days: any[];
  months: any[];
  years: any[];
  leapDate: any[];
  commonDate: any[];
  monthNames: any[];
  minYear: number;
  maxYear: number;
  selectedDate?: number;
  selectedMonth?: number;
  selectedYear?: number;
}
export class TNKDateDropdownComponent
  implements OnInit, OnChanges, AfterContentInit {
public dob: any;
public bindForm: FormGroup;
public bindControlName: string;
public disabledInput: boolean;
public maxYear: number;
public dateData: Observable<DateDropdown>;
public dispatcher: BehaviorSubject<DateDropdown>;
public dateStore: DateDropdown;
public selectedFullDate = new EventEmitter<string>();
constructor() {
    this.dispatcher = <BehaviorSubject<DateDropdown>>new BehaviorSubject({});
    this.dateData = this.dispatcher.asObservable();
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.dateData.subscribe(data => {
      this.dateStore = data;

      this.setFullDate(
        this.dateStore.selectedYear,
        this.dateStore.selectedMonth,
        this.dateStore.selectedDate,
      );
    });
  }
/**
 * @return {?}
 */
ngOnChanges() {
    setTimeout(() => {
      if (this.dob) {
        const /** @type {?} */ nullDate = new Date();
        nullDate.setFullYear(nullDate.getFullYear() - 21);

        const /** @type {?} */ defaultDate = this.dob ? new Date(this.dob) : nullDate;
        this.setStore({
          selectedDate: defaultDate.getDate(),
          selectedMonth: defaultDate.getMonth(),
          selectedYear: defaultDate.getFullYear(),
        });

        this.dispatcher.next(this.dateStore);
      }
    }, 50);
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    const /** @type {?} */ nullDate = new Date();
    nullDate.setFullYear(nullDate.getFullYear() - 21);

    const /** @type {?} */ defaultDate = this.dob ? new Date(this.dob) : nullDate;

    this.dateStore = {
      days: [],
      months: [],
      years: [],
      leapDate: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      commonDate: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      minYear: new Date().getFullYear() - 80,
      maxYear: this.maxYear ? this.maxYear : new Date().getFullYear(),
      monthNames: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
    };

    this.setStore({
      selectedDate: defaultDate.getDate(),
      selectedMonth: defaultDate.getMonth(),
      selectedYear: defaultDate.getFullYear(),
    });

    this.dispatcher.next(this.dateStore);
    this.onChangeYear();
  }
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ tmpObj = ( /** @type {?} */((<any>Object))).assign({}, obj);
    this.dateStore = ( /** @type {?} */((<any>Object))).assign(this.dateStore, tmpObj);
  }
/**
 * @param {?} y
 * @param {?} m
 * @param {?} d
 * @return {?}
 */
public setFullDate(y, m, d) {
    const /** @type {?} */ rawMonth = parseInt(m) + 1;
    const /** @type {?} */ month = rawMonth < 10 ? `0${rawMonth}` : rawMonth;
    const /** @type {?} */ date = d < 10 ? `0${d}` : d;

    this.selectedFullDate.emit(`${y}-${month}-${date}`);
  }
/**
 * @param {?=} event
 * @return {?}
 */
public onChangeDate(event?) {
    const /** @type {?} */ value = event ? event.target.value : this.dateStore.selectedDate;
    const /** @type {?} */ days = [];
    const /** @type {?} */ months = [];
    const /** @type {?} */ years = [];

    const /** @type {?} */ month = this.dateStore.selectedMonth;

    if (
      (this.dateStore.selectedYear % 4 === 0 &&
        this.dateStore.selectedYear % 100 !== 0) ||
      this.dateStore.selectedYear % 400 === 0
    ) {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.leapDate[month]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    } else {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.commonDate[month]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    }

    this.setStore({
      selectedDate: value,
      days: days,
      months: months,
      years: years,
    });
    this.dispatcher.next(this.dateStore);
  }
/**
 * @param {?=} event
 * @return {?}
 */
public onChangeMonth(event?) {
    const /** @type {?} */ value = event ? event.target.value : this.dateStore.selectedMonth;
    const /** @type {?} */ days = [];
    const /** @type {?} */ months = [];
    const /** @type {?} */ years = [];

    if (
      (this.dateStore.selectedYear % 4 === 0 &&
        this.dateStore.selectedYear % 100 !== 0) ||
      this.dateStore.selectedYear % 400 === 0
    ) {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.leapDate[value]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    } else {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.commonDate[value]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    }

    this.setStore({
      selectedMonth: value,
      days: days,
      months: months,
      years: years,
    });
    this.dispatcher.next(this.dateStore);
  }
/**
 * @param {?=} event
 * @return {?}
 */
public onChangeYear(event?) {
    const /** @type {?} */ value = event
      ? parseInt(event.target.value)
      : this.dateStore.selectedYear;
    const /** @type {?} */ days = [];
    const /** @type {?} */ months = [];
    const /** @type {?} */ years = [];
    const /** @type {?} */ month = this.dateStore.selectedMonth;

    if ((value % 4 === 0 && value % 100 !== 0) || value % 400 === 0) {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.leapDate[month]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    } else {
      for (let /** @type {?} */ i = 1; i <= this.dateStore.commonDate[month]; i++) {
        days.push(i);
      }

      for (let /** @type {?} */ i = 0; i < this.dateStore.monthNames.length; i++) {
        months.push(this.dateStore.monthNames[i]);
      }

      for (let /** @type {?} */ i = this.dateStore.maxYear; i >= this.dateStore.minYear; i--) {
        years.push(i);
      }
    }

    this.setStore({
      selectedYear: value,
      days: days,
      months: months,
      years: years,
    });
    this.dispatcher.next(this.dateStore);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'date-dropdown',
  template: `
    <div class="col-sm-4 col-xs-4" style="padding-left: 0">
      <div class="review-form-field-input">
        <div class="form-group">
          <select
            class="form-control"
            id="inp_tgl_lahir"
            (change)="onChangeDate($event)"
            [(ngModel)]="dateStore.selectedDate"
            [disabled]="disabledInput"
          >
            <option *ngFor="let list of dateStore.days" [value]="list">
              {{ list }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-sm-4 col-xs-4">
      <div class="review-form-field-input">
        <div class="form-group">
          <select
            class="form-control"
            id="inp_bln_lahir"
            (change)="onChangeMonth($event)"
            [(ngModel)]="dateStore.selectedMonth"
            [disabled]="disabledInput"
          >
            <option
              *ngFor="let list of dateStore.months; let i = index"
              [value]="i"
            >
              {{ list }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-sm-4 col-xs-4" style="padding-right: 0">
      <div class="review-form-field-input">
        <div class="form-group">
          <select
            class="form-control"
            id="inp_thn_lahir"
            (change)="onChangeYear($event)"
            [(ngModel)]="dateStore.selectedYear"
            [disabled]="disabledInput"
          >
            <option *ngFor="let list of dateStore.years" [value]="list">
              {{ list }}
            </option>
          </select>
        </div>
      </div>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dob': [{ type: Input, args: ['dob', ] },],
'bindForm': [{ type: Input, args: ['bindForm', ] },],
'bindControlName': [{ type: Input, args: ['bindControlName', ] },],
'disabledInput': [{ type: Input, args: ['disabledInput', ] },],
'maxYear': [{ type: Input, args: ['maxYear', ] },],
'selectedFullDate': [{ type: Output, args: ['dateModel', ] },],
};
}

function TNKDateDropdownComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKDateDropdownComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKDateDropdownComponent.ctorParameters;
/** @type {?} */
TNKDateDropdownComponent.propDecorators;
/** @type {?} */
TNKDateDropdownComponent.prototype.dob;
/** @type {?} */
TNKDateDropdownComponent.prototype.bindForm;
/** @type {?} */
TNKDateDropdownComponent.prototype.bindControlName;
/** @type {?} */
TNKDateDropdownComponent.prototype.disabledInput;
/** @type {?} */
TNKDateDropdownComponent.prototype.maxYear;
/** @type {?} */
TNKDateDropdownComponent.prototype.dateData;
/** @type {?} */
TNKDateDropdownComponent.prototype.dispatcher;
/** @type {?} */
TNKDateDropdownComponent.prototype.dateStore;
/** @type {?} */
TNKDateDropdownComponent.prototype.selectedFullDate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
